import './style/profile.css';
import React, { useEffect, useState } from 'react'
import axios from 'axios';
// import { Link } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
// import { Redirect } from 'react-router';

const UpdateProf = (props) => {
  
    const [uname, setName] = useState("");
    const [uemail, setEmail] = useState("");
    const [umobile, setmobile] = useState("");
    const [upass, setPass] = useState("");
    const [uaddress, setAddress] = useState("");
    const [msg, setMessage] = useState("");

    const [npass, setNPass] = useState("");
    const [cpass, setCPass] = useState("");
    const [opass, setOPass] = useState("");

    if(false)
  {
    //did this to remove warnings
      console.log(upass);
  }

    const onChangeName = (e) => setName(e.target.value);
    const onChangeMobile = (e) => setmobile(e.target.value);
    const onChangeAddress = (e) => setAddress(e.target.value);
    const onChangeCPass = (e) => setCPass(e.target.value);
    const onChangeNPass = (e) => setNPass(e.target.value);
    const onChangeOPass = (e) => setOPass(e.target.value);

    const [error0, setError0] = useState("");
    const [valid0, setValid0] = useState(true);
    const [error2, setError2] = useState("");
    const [valid2, setValid2] = useState(true);
    const [error3, setError3] = useState("");
    const [valid3, setValid3] = useState(true);
    const [error4, setError4] = useState("");
    const [valid4, setValid4] = useState(true);
    const [error5, setError5] = useState("");
    const [valid5, setValid5] = useState(true);
    const [error6, setError6] = useState("");
    const [valid6, setValid6] = useState(true);

    let authuser = sessionStorage.getItem('Key_Veriable');

    function showHide() {
      if(authuser==="ADMIN") {
          document.getElementById('oldpassword').style.display = 'none';
          document.getElementById('oldpassword1').style.display = 'none';
          document.getElementById('oldpassword3').style.display = 'none';
          document.getElementById('deletebutton4').style.display = 'none'
          setOPass("anyrandomvaluetosetdefault")
          // 'oldpassword'.style.display = 'block'
      } else {
          document.getElementById('oldpassword').style.display = 'inline';
          document.getElementById('oldpassword1').style.display = 'inline';
          document.getElementById('oldpassword3').style.display = 'inline';
          // 'oldpassword'.style.display = 'none'
      }
  }

    const onBlurName = (e) => {
        // setValid[3](false);
        if (!uname) {
            setValid0(false);
            //setErrors({"name":"Please enter your name."});
            setError0("Please enter your name.");
          }
          else{
            setValid0(true);
            setError0("");
          }
          if (typeof uname !== "undefined") {
            // const re = /^\S*$/;
            // const re =/^[a-zA-Z][a-zA-Z\\s]+$/;
            const re = /^[a-zA-Z ]{2,40}$/;
            if(uname.length < 3 || !re.test(uname)){
                setValid0(false);
               // setErrors({"name":"Please enter valid name."});
               setError0("Please enter valid name.");
            }
            else{
                setValid0(true);
                setError0("");
              }
          }
          
    }
     const onBlurMobile = (e) => {	
    //    mobnoexp = /^[6789][0-9]{9}$/;
    //var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
       /*
       ^       #Match the beginning of the string
      (7|8|9)  #Match a 7, 8 or 9 digit
      \d       #Match a digit (0-9 and anything else that is a "digit")
      {9}      #Repeat the previous "\d" 9 times (9 digits)
      $        #Match the end of the string
       */
      //    var mobno = document.getElementById("mobno").value;
        //  alert(umobile);
        if (!umobile) {
            setValid2(false);
            setError2("Please enter your phone number.");
            //setErrors({"name":"Please enter valid name."});
          }
          else{
            setValid2(true);
            setError2("");
          }
           if (typeof umobile !== "undefined") {
            var pattern = new RegExp(/^[0-9\b]+$/);
            if (!pattern.test(umobile)) {
                setValid2(false);
              setError2("Please enter only number.");
              //setErrors({"name":"Please enter valid name."});
            }
            else{
                setValid2(true);
                setError2("");
              }
            if(umobile.length !== 10){
                setValid2(false);
              setError2("Please enter valid phone number.");
              //setErrors({"name":"Please enter valid name."});
            }
            else{
                setValid2(true);
                setError2("");
              }
          }
      }
      const onBlurAddress = (e) => {

        if (!uaddress) {
            setValid3(false);
            setError3("Please enter your address.");
          }
          else{
            setValid3(true);
            setError3("");
          }
    }

    const onBlurOPass = (e) => {
      const logininfo = {
        empemail: uemail.toLowerCase(),
        emppass: opass
      }
        if (authuser!=="ADMIN" && !opass) {
            setValid6(false);
            setError6("Please enter your old password.");
          }
          else{
            setValid6(true);
                 setError6("");
          }
          if(authuser==="USER")
          {
            console.log(logininfo);
              axios.post('https://akshatngupta-bike-rental.herokuapp.com/user/logincheck', logininfo)
                 .then(res => {
                 console.log(res.data)
                // sessionStorage.setItem("Key_Veriable", 'USER')
                // sessionStorage.setItem("email", res.data.email)
                // sessionStorage.setItem("name", res.data.name)
                // history.push('/userafterlogin')
                 // <Link to="/signup"></Link>
                 setValid6(true);
                 setError6("");
                })
                .catch(err => {
                 console.log(err)
                 setValid6(false);
                //  flag=false;
                 setError6("Please Enter Valid Old Password.");
                })
          }
    }
    // var flag=true;
    // function chechvalidold()
    // {
    //   console.log(logininfo);
    //   axios.post('http://localhost:4500/user/logincheck', logininfo)
    //      .then(res => {
    //      console.log(res.data)
    //     // sessionStorage.setItem("Key_Veriable", 'USER')
    //     // sessionStorage.setItem("email", res.data.email)
    //     // sessionStorage.setItem("name", res.data.name)
    //     // history.push('/userafterlogin')
    //      // <Link to="/signup"></Link>
    //      setValid6(true);
    //      setError6("");
    //     })
    //     .catch(err => {
    //      console.log(err)
    //      setValid6(false);
    //      falg=false;
    //      setError6("Please Enter Valid Old Password.");
    //     })
    // }

    const onBlurNPass = (e) => {
        if ( !npass) {
            setValid4(false);
            setError4("Please enter your password.");
            //setErrors({"name":"Please enter valid name."});
          }
          else{
            setValid4(true);
            setError4("");
          }
           if (typeof npass !== "undefined") {
            if(npass.length < 6){
                setValid4(false);
                setError4("Please add at least 6 charachter.");
                //setErrors({"name":"Please enter valid name."});
            }
          }
          else{
            setValid4(true);
            setError4("");
          }
          if (cpass) {   
            if (npass !== cpass) {
                setValid5(false);
              setError5("Passwords don't match.");
            }
            else{
                setValid5(true);
                setError5("");
              }
          }
    }
    const onBlurCPass = (e) =>{
        if (!cpass) {
            setValid5(false);
            setError5("Please confirm your password.");
          } 
          else{
            setValid5(true);
            setError5("");
          }
        //   if(npass.length < 6){
        //     setValid({"confirm_password":false});
        //     errors["confirm_password"] = "Please add at least 6 charachter.";
        //     //setErrors({"name":"Please enter valid name."});
        // }
        // else{
        //     setValid({"confirm_password":true});
        //     errors["confirm_password"] = "";
        //   }
          if (cpass  && npass ) {   
            if (cpass !== npass) {
                setValid5(false);
              setError5("Passwords don't match.");
            }
            else{
                setValid5(true);
                setError5("");
              }
          }
    }



    const handleSubmit = async (evt) => {
      evt.preventDefault();

      console.log(`le raha?`);
        if(valid0===false||  valid2===false || valid3===false || valid4===false || valid5===false || valid6===false)
            setMessage("ENTER VALID CREDENTIALS");
        else
        {

        // evt.preventDefault();
        console.log(`Checking`);
        console.log(`Form submitted:`);
        console.log(`NAME: ${uname}`);
        console.log(`EMAIL: ${uemail}`);

        const info = {
            empname: uname,
            empemail: uemail,
            empmobile: umobile,
            emppass: npass,
            empaddress: uaddress
        }
          axios.put('https://akshatngupta-bike-rental.herokuapp.com/user/update', info)
            .then(res => {
                console.log(res.data)
                setMessage('PROFILE UPDATED');
            });
        

        setName('')
        setmobile('')
        setNPass('')
        setOPass('')
        setCPass('')
        setAddress('')
        setError0("")
        setValid0(true)
        setError2("")
        setValid2(true)
        setError3("")
        setValid3(true)
        setError4("")
        setValid4(true)
        setError5("")
        setValid5(true)
        setError6("")
        setValid6(true)
	}
}

const handleClick = event => {
  event.preventDefault();
  // let values = event.target.dataset.mssg.split("_")
  //   let email = values[0]
  // let demail=sessionStorage.getItem()
    axios.delete('https://akshatngupta-bike-rental.herokuapp.com/user/remove/' +uemail)
    .then(res => {
      console.log(res.data)
      axios.delete('https://akshatngupta-bike-rental.herokuapp.com/booking/removeall/' + uemail)
      .then(res => {
      console.log(res.data)
      setMessage('SUCCESSFULLY DELETED')
      })
      .catch(err => {
      console.log(err)
      setMessage('INVALID USER ID')
      })
      setMessage('SUCCESSFULLY DELETED')
      if(authuser==="USER")
      props.history.push("./logout")
      // if(authuser==="ADMIN")
      // props.history.push("./manageusers")
      setEmail("")
      setName("")
      setmobile("")
    })
    .catch(err => {
      console.log(err)
      setMessage('INVALID USER ID')
    })
  }

  //Similar to componentDidMount and componentDidUpdate
  useEffect(() => {
    //"/updateprofile/:emailid"
    // window.location.pathname.split()
    showHide();
    let emailid = sessionStorage.getItem('email')
    console.log(emailid)
    if (emailid == null)
    {
        emailid = props.email
    }
    axios.get('https://akshatngupta-bike-rental.herokuapp.com/user/search/' + emailid)
        .then(response => {
            console.log(response.data)
            const { name, email, mobile, pass, address } = response.data[0]
            setName(name)
            setEmail(email)
            setmobile(mobile)
            setPass(pass)
            // setOPass(pass)
            setAddress(address)
        })
        .catch((error) => {
            console.log(error);
        })
}, [])

  return (
    <div id={'in'}>
    <Header />
    <div className='main'>
        <div className='container'>
            <div className='bike-container'>
                <div className='bg-color'>
                    <div className='bike'>
                        <img src={require(`../assets/duke.png`)} alt='' />
                    </div>
					<form onSubmit={handleSubmit}>
                        <div className="form2">
                            <b>
						    <h3>Update Profile</h3></b>
                            <b style={{ color: "brown" }}> {msg}</b>
							<p><label className="labels">Name</label></p>
							<input type="text" className="form-control" value={uname} onBlur={onBlurName} onChange={onChangeName} placeholder="Enter Name" required />
							<div><b className="text-danger" style={{ color: "red" }}>{error0}</b></div>
                            <label className="labels">Email</label>
							<input type="email" className="form-control" value={uemail} placeholder={uemail} readOnly/>
                            <label className="labels">Mobile No.</label>
							<input type="number" className="form-control" value={umobile} onBlur={onBlurMobile} onChange={onChangeMobile} placeholder="Enter Mobile" required />
							<div><b className="text-danger" style={{ color: "red" }}>{error2}</b></div>
                            <label className="labels">Address</label>
							<input type="address" className="form-control"  value={uaddress} onBlur={onBlurAddress} onChange={onChangeAddress} placeholder="Enter Address" required/>
                            <div><b className="text-danger" style={{ color: "red" }}>{error3}</b></div>
                            
                            <label name="label1" className="labels" id="oldpassword1" >Old Password</label>
                           <br/>
                            <input type="password" className="form-control" id="oldpassword" placeholder="Enter Old password" value={opass} onBlur={onBlurOPass} onChange={onChangeOPass} required/>
                            <br/>
                            <div id="oldpassword3" ><b className="text-danger" style={{ color: "red" }}>{error6}</b></div>
                            <br/>
                            <label className="labels">New Password</label>
                            <input type="password" className="form-control" placeholder="Enter New password"  value={npass} onBlur={onBlurNPass} onChange={onChangeNPass} required/>
                            <div><b className="text-danger" style={{ color: "red" }}>{error4}</b></div>
                            <label className="labels">Confirm New Password</label>
                            <input type="password" className="form-control" placeholder="Confirm New password"  value={cpass} onBlur={onBlurCPass} onChange={onChangeCPass} required/>	
                            <div><b className="text-danger" style={{ color: "red" }}>{error5}</b></div>
                            <div>
                            <button type="submit"  className='Button3' value="REGISTER">Update</button>
                                </div>
                        </div>
					</form>
				</div>
            </div>
        </div>
    </div>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <button id="deletebutton4" className='Button4' onClick={handleClick} >Delete Profile</button>
    <br/>
    <Footer />
    </div>
  );
};
export default UpdateProf;